/**
 * Route for `real-time-conversion-fraud-detection`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeConversionFraudDetectionPage } from "../features/real-time-conversion-fraud-detection/RealTimeConversionFraudDetectionPage";

export const realTimeConversionFraudDetectionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-conversion-fraud-detection",
	component: RealTimeConversionFraudDetectionPage,
});

export default realTimeConversionFraudDetectionRoute;
